import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import CustomHelmet from '../Helmet/Helmet';
import Actualite from '../Actualite/Actualite';
import Activites from '../Activites/Activites';
import Menu from '../Menu/Menu';
import Publications from '../Publications/Publications';
import Summary from '../Summary/Summary';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Cours from '../Cours/Cours';
import CoursEstimation2019 from '../CoursEstimation2019';
import CoursEstimation2018 from '../CoursEstimation2018';
import CoursAnalyseExploratoire2018 from '../CoursAnalyseExploratoire2018';
import CoursModelesPourLaDatascience2018 from '../CoursModelesPourLaDatascience2018';
import Talks from '../Talks/Talks';
import CoursBaseDeDonnees2019 from '../CoursBaseDeDonnees2019';
import './App.css';
import metadata from '../../metadata/metadata.json';


class App extends Component {

    render() {
        return (
            <Router>

                <div className="App">
                    <div className="container-fluid">
                        <div className="row">

                            <div className="menu-container col-md-3 col-xs-12">
                                <Menu />
                            </div>

                            <Route exact={true} path="/" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <Summary />
                                    <Activites />
                                    <Publications />
                                    <Actualite />
									<Cours />
                                    <Talks />
                                    <Footer />
                                </div>
                            )} />

                            <Route exact={true} path="/cours" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <Cours />
                                    <Footer />
                                </div>
                            )} />


							 <Route exact={true} path="/cours-estimation-2019" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <CoursEstimation2019  />
                                    <Footer />
                                </div>
                            )} />

							<Route exact={true} path="/cours-estimation-2018" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <CoursEstimation2018 />
                                    <Footer />
                                </div>
                            )} />


							<Route exact={true} path="/cours-analyse-exploratoire-2018" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <CoursAnalyseExploratoire2018 />
                                    <Footer />
                                </div>
                            )} />

                            <Route exact={true} path="/cours-modeles-pour-la-datascience-2018" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <CoursModelesPourLaDatascience2018 />
                                    <Footer />
                                </div>
                            )} />


							<Route exact={true} path="/cours-base-de-donnees-2019" component={()=> (
                                <div className="home-container col-md-9 col-xs-12">
                                    <CustomHelmet
                                        name={metadata.name}
                                        description={metadata.description}
                                        url={metadata.url}
                                    />
                                    <Header />
                                    <CoursBaseDeDonnees2019 />
                                    <Footer />
                                </div>
                            )} />

                        </div>
                    </div>
                </div>

            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js